<template>
  <v-container fill-height>
    <v-row class="align-center justify-center" >
      <v-col  style="max-width:500px">
        <v-card v-if="statusAccountActivation === 'success'" textcolor="transparent" >
          <v-alert type="info" value="1">{{$t("Account activated")}}</v-alert>
          <v-card-text>{{$t("You can now log in with your account.")}}</v-card-text>
          <v-divider></v-divider>
          <v-card-actions>
            <v-spacer></v-spacer>
            <v-btn roundedcolor="primary" :to="{name: 'login'}">
              Log In
            </v-btn>
          </v-card-actions>
        </v-card>
        <v-card v-else-if="statusAccountActivation === 'failure'" textcolor="transparent" >
          <v-alert type="error" value="1">{{$t("Account activation error")}}</v-alert>
          <v-card-text>Link is invalid.</v-card-text>
          <v-divider></v-divider>
          <v-card-actions>
            <v-spacer></v-spacer>
            <v-btn roundedcolor="primary" :to="{name: 'login'}">
              Log In
            </v-btn>
          </v-card-actions>
        </v-card>
      </v-col>
    </v-row>
  </v-container>
</template>

<script>
import { mapState, mapActions } from "vuex";

export default {
  computed: {
    ...mapState({
      statusAccountActivation: ({ user }) => user.statusAccountActivation,
      statusAuth: ({ auth }) => auth.status,
      loading: function() {
        return this.statusAccountActivation === "fetching";
      }
    })
  },

  mounted() {
    if (this.statusAuth === "success") {
      this.logout();
    } else {
      this.activateAccount({ token: this.$route.params.token });
    }
  },

  watch: {
    statusAccountActivation(val) {
      if (val === "success") {
        // setTimeout(() => {
        //   this.$router.push("/login");
        // }, 3000);
      }
    }
  },

  methods: {
    ...mapActions("user", ["activateAccount"]),
    ...mapActions("auth", ["logout"])
  }
};
</script>
